import { Action, createReducer, on } from '@ngrx/store';
import { CentralLocationGridData } from '../../shared/models/location-stat';
import * as MessageHubActions from '../../../../state/actions/message-hub.actions';
import * as CentralLocationViewActions from '../actions/lobby-central-location-view.actions';

export interface LobbyCentralLocationViewState {
    searchText: string;
    gridData: CentralLocationGridData;
    tenantId: number;
    signInLocationId: number;
    locationFilters: number[];
    page: number;
    pageSize: number;
    sortColumn: string;
    sortDirection: string;
    subscribeToCentralLocationGridData: boolean;
}

const initialLobbyCentralLocationViewState: LobbyCentralLocationViewState = {
    searchText: '',
    gridData: {
        totalRowCount: 0,
        data: [],
        currentPageNumber: 1,
        pageSize: 25,
        numberOfPages: 0
    },
    tenantId: 0,
    signInLocationId: 0,
    locationFilters: [],
    page: 1,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    subscribeToCentralLocationGridData: true
};

const reducer = createReducer<LobbyCentralLocationViewState>(
    initialLobbyCentralLocationViewState,
    on(MessageHubActions.receivedCentralBranchStatusGridData, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            gridData: (action.messageData !== '') ? JSON.parse(action.messageData) : {}
        }
    )),
    on(CentralLocationViewActions.setCentralLocationGridPage, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            page: action.page,
            pageSize: action.pageSize,
            subscribeToCentralLocationGridData: true
        }
    )),
    on(CentralLocationViewActions.setCentralLocationGridSort, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            sortColumn: (action.sortDirection === undefined) ? '' : action.sortColumn,
            sortDirection: (action.sortDirection === undefined) ? '' : (action.sortDirection === 'asc') ? 'asc' : 'desc',
            subscribeToCentralLocationGridData: true
        }
    )),
    on(CentralLocationViewActions.reSubscribtionToCentralLocationGridData,
        (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            subscribeToCentralLocationGridData: true
        }
    )),
    on(MessageHubActions.joinCentralLocationGroupActionComplete, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            subscribeToCentralLocationGridData: false
        }
    )),
    on(CentralLocationViewActions.setCentralLocationGridTenantId, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            tenantId: action.tenantId,
            subscribeToCentralLocationGridData: true
        }
    )),
    on(CentralLocationViewActions.setCentralLocationGridLocationId, (lobbyCentralLocationViewState, action): LobbyCentralLocationViewState => (
        {
            ...lobbyCentralLocationViewState,
            signInLocationId: action.locationId,
            subscribeToCentralLocationGridData: true
        }
    ))
);

export function lobbyCentralLocationViewReducer(state: LobbyCentralLocationViewState | undefined, action: Action) {
    return reducer(state, action);
}
